import { render } from "./enterpriseAllocation.vue?vue&type=template&id=f95db79c&scoped=true"
import script from "./enterpriseAllocation.vue?vue&type=script&lang=js"
export * from "./enterpriseAllocation.vue?vue&type=script&lang=js"

import "./enterpriseAllocation.vue?vue&type=style&index=0&id=f95db79c&scoped=true&lang=css"
import "./enterpriseAllocation.vue?vue&type=style&index=1&id=f95db79c&lang=css"
script.render = render
script.__scopeId = "data-v-f95db79c"

export default script